import { languageHelper } from "../../../config/helperFunctions";
import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function CustomerRecieve() {
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "SN",
    
    },
    {
      header: languageHelper("Reference No"),
      accessorKey: "ReferenceNo"
    },
    {
      header: languageHelper("Date"),
      accessorKey: "Date",
    },
    {
      header: languageHelper("Customer"),
      accessorKey: "Customer",
    },
    {
      header: languageHelper("Amount"),
      accessorKey: "Amount",
    },
    {
      header: languageHelper("Note"),
      accessorKey: "Note",
    },
   
    {
      header: languageHelper("Added By"),
      accessorKey: "AddedBy",
    },
    {
      header: languageHelper("Actions"),
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([

  
  ]);
  const [buttonData] = useState([   
    {
      buttonText: languageHelper("Add Customer Due Receives"),
      path: "addCustomerRecieveForm"
    },
    
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Customer Due Receives")}
        buttonData={buttonData}
      

      />
    </main>
  );
}

export default CustomerRecieve;
